import { Component, HostListener, Inject, OnInit } from '@angular/core';
import {LoginComponent} from '../login/login.component';
import {MdDialog} from '@angular/material';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'home-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HomeHeaderComponent implements OnInit {

  public scrollTop = 0;

  constructor(public dialog: MdDialog, @Inject(DOCUMENT) private document: any) { }

  @HostListener('window:scroll', [])

  onWindowScroll() {
    this.scrollTop = this.document.body.scrollTop;
  }

  loginDialog() {
    let dialogRef = this.dialog.open(LoginComponent);
    dialogRef.componentInstance.onLogin.subscribe(() => {
     dialogRef.close();
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/home/header/header.component.ts